import { render, staticRenderFns } from "./parts-locations-sms-email.vue?vue&type=template&id=675ab3cf&scoped=true&"
import script from "./parts-locations-sms-email.vue?vue&type=script&lang=js&"
export * from "./parts-locations-sms-email.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations-sms-email.vue?vue&type=style&index=0&id=675ab3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ab3cf",
  null
  
)

export default component.exports